export const paths = {
  home: "/",
  franklin: "/angebote/franklin",
  meditationInMotion: "/angebote/meditation-in-bewegung",
  viaIntegralis: "/angebote/via-integralis",
  team: "/team",
}
